module.exports = __webpack_public_path__ + "specialistHelp.a7da4afd0de72dacd4c91f86f4b25671.png";